import styled, { css } from 'styled-components';

import { VideoPreviewProps } from './VideoPreview';

export const VideoPreviewContainer = styled.div`
	${({ theme }) => css`
		position: relative;
		width: 100%;
		background-color: #f1f1f1;
		border-radius: ${theme.radii.m};
		box-shadow: ${theme.shadows.base};

		@supports (aspect-ratio: 1/1) {
			aspect-ratio: 1 / 1;
		}

		@supports not (aspect-ratio: 1/1) {
			padding-top: 100%;
			height: 0;
			overflow: hidden;
		}

		@media ${theme.screens.screenGTS} {
			width: 296px;
		}

		@media ${theme.screens.screenL} {
			width: 330px;
		}
	`}
`;

export const VideoPreviewCamDisabled = styled.div`
	${({ theme }) => css`
		display: grid;
		place-content: center;
		height: 100%;
		overflow: hidden;
		border-radius: ${theme.radii.m};

		background-color: ${theme.colors.neutral[500]};
	`}
`;

export const VideoPreviewPlaceholder = styled.div`
	display: grid;
	place-content: center;
	height: 100%;
`;

export const VideoPreviewPlaceholderInfo = styled.div`
	position: absolute;
	background-color: #aaaaaa;
	border-radius: 10px;
	color: #ffffff;
	font-size: 15px;
	padding: 8px;
	top: 20px;
	right: 48px;
	left: 48px;

	display: grid;
	grid-template-columns: 42px 1fr;
`;

export const VideoPreviewPlaceholderInfoIcon = styled.div`
	text-align: center;
`;

export const Video = styled.div<VideoPreviewProps>`
	${({ theme, $mirror }) => css`
		width: 100%;
		height: 100%;
		object-fit: cover;
		${$mirror && 'transform: scaleX(-1);'}
		overflow: hidden;
		border-radius: ${theme.radii.m};
	`};
`;
